import { render, staticRenderFns } from "./EWallet.vue?vue&type=template&id=9638a9bc&"
import script from "./EWallet.vue?vue&type=script&lang=js&"
export * from "./EWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports